import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

// Initial State
const initialState = {
  allPosts: [], // All posts (can be fetched for other pages)
  userPosts: [], // User-specific posts
};

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    // Reducer to set all posts
    setAllPosts: (state, action) => {
      state.allPosts = action.payload;
    },

    // Reducer to set posts belonging to the logged-in user
    setUserPosts: (state, action) => {
      state.userPosts = action.payload;
    },

    // Optional: Add a toggle like reducer for additional functionality
    toggleLike: (state, action) => {
      const { postId, userId } = action.payload;

      const post = state.userPosts.find((p) => p.id === postId);
      if (post) {
        if (post.likes?.includes(userId)) {
          // Remove like
          post.likes = post.likes.filter((id) => id !== userId);
          post.likeCount = (post.likeCount || 1) - 1;
        } else {
          // Add like
          post.likes.push(userId);
          post.likeCount += 1;
        }
      }
    },
  },
});

// Action creators
export const { setAllPosts, setUserPosts, toggleLike } = postsSlice.actions;

// Export the reducer
export default postsSlice.reducer;

// ==================== Memoized Selectors ====================

// Basic selectors to access posts state
const selectPostsState = (state) => state.posts;

// Memoized selector for all posts
export const selectAllPosts = createSelector(
  [selectPostsState],
  (postsState) => postsState.allPosts
);

// Memoized selector for user posts
export const selectUserPosts = createSelector(
  [selectPostsState],
  (postsState) => postsState.userPosts
);
